import { soulsmithColors } from "./visualTokens";

export const rarityTheme = {
  common: {
    color: "#ffffff",
    label: "Common",
    orb: { glow: 0.1, particles: 0, pulseMs: 1800 },
    blender: { emissiveIntensity: 0, particleBudget: 0 },
    pixi: { border: "#ffffff", damageNumber: "#ffffff" }
  },
  uncommon: {
    color: "#57a65a",
    label: "Uncommon",
    orb: { glow: 0.3, particles: 20, pulseMs: 1500 },
    blender: { emissiveIntensity: 0.3, particleBudget: 20 },
    pixi: { border: "#57a65a", damageNumber: "#9adf9c" }
  },
  rare: {
    color: "#2f70c8",
    label: "Rare",
    orb: { glow: 0.6, particles: 50, pulseMs: 1200 },
    blender: { emissiveIntensity: 0.6, particleBudget: 50 },
    pixi: { border: "#2f70c8", damageNumber: "#8bb8ff" }
  },
  legendary: {
    color: soulsmithColors.voidPurple,
    label: "Legendary",
    orb: { glow: 1, particles: 100, pulseMs: 950 },
    blender: { emissiveIntensity: 1, particleBudget: 100 },
    pixi: { border: soulsmithColors.voidPurple, damageNumber: soulsmithColors.neuralViolet }
  },
  mythic: {
    color: soulsmithColors.emberOrange,
    label: "Mythic",
    orb: { glow: 2, particles: 200, pulseMs: 720 },
    blender: { emissiveIntensity: 2, particleBudget: 200 },
    pixi: { border: soulsmithColors.antiqueGold, damageNumber: soulsmithColors.emberOrange }
  },
  primal: {
    color: soulsmithColors.primalWhiteGold,
    label: "Primal",
    orb: { glow: 2.5, particles: 260, pulseMs: 420 },
    blender: { emissiveIntensity: 2.5, particleBudget: 260 },
    pixi: { border: soulsmithColors.primalWhiteGold, damageNumber: soulsmithColors.primalWhiteGold }
  }
} as const;

export type RarityName = keyof typeof rarityTheme;
